// Runtime webpack config
import '../../other/WebpackConfig';

import '../../../scss/l1CarsPage.twh.frbe.scss';

// i18n
import i18n from '../../i18n/fr-BE';

import l1CarsPage from './l1CarsPage';

l1CarsPage(i18n);
